export const REPORT_DICTIONARY = [
  {
    options: "report_param_type",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "report_param_type",
    entitySpec: "ref",
  },
];
export const USER_REQUIRED_FILEDS = {
  user_name: true,
  user_firstname: true,
  user_lastname: true,
  user_middlename: true,
}
export const REPORT_TEMPLATE_COLUMNS = [
  { header: "ID", field: "report_template_id" },
  { header: "Код", field: "report_template_code" },
  { header: "Наименование", field: "report_template_name" },
  { header: "Системное имя", field: "report_template_sysname" },
  { header: "Компании", field: "company_marks" },
  { header: "Состояние", field: "report_state_name" },
];
export const AUDIT_COLUMNS = [
  { header: "ID", field: "log_report_id", sortable: true },
  { header: "Наименование", field: "report_template_name", sortable: true },
  { header: "Пользовтаель", field: "log_report_user", sortable: true },
  { header: "Подкл. пользователь", field: "original_user", sortable: true },
  { header: "Команда", field: "log_report_command" },
  { header: "Дата", field: "log_report_date", conversion: true, gmt: true, dataType: "date-time", sortable: true },
];
export const AUDIT_TOOLBAR_FILTER = [
  {
    name: "periods",
    enabled: true,
    required: true,
    default: "За месяц",
  }
];
export const REPORT_FILTERS = [
  {
    options: "user",
    save: { store: false, self: true },
    load: "self",
    keyName: "create_user_sname",
    valueName: "create_user_sname",
  },
];
export const REPORT_COLUMNS = [
  {
    header: "ID",
    sortable: true,
    field: "report_id",
    filterData: {
      show: true,
      type: "InputText",
      "max-width": "40px",
      placeholder: "...",
    },
  },
  {
    header: "Код",
    field: "report_struct_code",
  },
  {
    header: "Наименование",
    field: "report_name",
    sortable: true,
    filterData: { show: true, type: "InputText", placeholder: "..." },
  },
  {
    header: "Модуль",
    field: "module_sname",
  },
  {
    header: "Задача",
    field: "task_name",
  },
  {
    header: "Сист. имя",
    field: "report_sysname",
    sortable: true,
  },
  {
    header: "Автор",
    field: "create_user_sname",
    sortable: true,
    filterData: {
      show: true,
      options: "user",
      placeholder: "...",
      type: "MultiSelect",
      mode: "in",
      valueName: "create_user_sname",
    },
  }
];
export const TEMPLATE_DICTIONARY = [
  {
    options: "companies",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "report_template_comp",
    entitySpec: "ref",
  },
  {
    options: "reportStates",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "report_state",
    entitySpec: "ref",
  },
  {
    options: "code",
    save: { store: false, self: true },
    load: "parent",
    data() {
      const code = [];
      for (let i = 1; i < 50; i++) code.push({ ["code"]: i });
      return code;
    },
  },
]